var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 71,
    viewBox: "0 0 58 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.13147 9.55318C4.13147 8.1113 3.25636 6.87047 2 6.31635C2.51887 5.91442 3.14767 5.63931 3.84157 5.5418L42.7699 0.0726008C47.1135 -0.537677 51 2.77722 51 7.09264V10C49.8478 9.7083 48.6396 9.55318 47.3947 9.55318H4.13147Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21 42.5C21 37.8057 24.5819 34 29 34C33.4181 34 37 37.8057 37 42.5C37 47.1943 33.4181 51 29 51C24.5819 51 21 47.1943 21 42.5Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.75 14.2008C54.9739 15.6785 58 19.6659 58 24.3529V60.2353C58 66.1806 53.1313 71 47.125 71H10.875C4.86892 71 0 66.1806 0 60.2353V10C0 10.6536 0.176538 11.2663 0.484953 11.7941C1.11175 12.8666 2.28324 13.5882 3.625 13.5882H47.125C48.3959 13.5882 49.6161 13.8041 50.75 14.2008ZM29 28.8382C21.4924 28.8382 15.4062 34.8625 15.4062 42.2941C15.4062 49.7257 21.4924 55.75 29 55.75C36.5077 55.75 42.5938 49.7257 42.5938 42.2941C42.5938 34.8625 36.5077 28.8382 29 28.8382Z",
    fill: "#8D90A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.4a0fb00cb6e6f26a633caa042371c23a.svg";
export { ForwardRef as ReactComponent };